<template>
    <el-dialog
        title="日程管理"
        :visible.sync="visible"
        width="800px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="schmodal"
    >
        <el-form
            label-width="100px" 
            :model="formData" 
            :rules="rules" 
            ref="formData"
        >
            <el-form-item label="标题：" prop="title">
                <el-input v-model="formData.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="startTime">
                <el-date-picker v-model="formData.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="endTime">
                <el-date-picker v-model="formData.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="地点：" prop="location">
                <el-input v-model="formData.location" clearable></el-input>
            </el-form-item>
            <el-form-item label="紧急程度：" prop="emergencyLevel">
                <el-radio-group v-model="formData.emergencyLevel">
                    <el-radio :label="1">一般</el-radio>
                    <el-radio :label="2">重要</el-radio>
                    <el-radio :label="3">紧急</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" v-model="formData.remark" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
            </el-form-item>
        </el-form>
        <div class="schmodal-btns">
            <el-button @click="visible = false;">取消</el-button>
            <el-button type="primary" @click="submitHandle">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {apiwbschedulemanagementsave,apiwbschedulemanagementget} from '@/server/new.js';
export default {
    data() {
        return {
            visible: false,
            formData: {
                id:'',
				title:'',//标题
				startTime:'',//开始时间
				endTime:'',//结束时间
				location:'',//地点
				emergencyLevel:1,//紧急程度
				remark:'',//备注
				completeStatus:0//是否完成
            },
            rules: {
				title:[{ required: true, message: '请输入标题', trigger: 'blur'}]
			}
        }
    },
    methods: {
        open(id) {
            if(id) {
                this.apiwbschedulemanagementget(id)
            }
            this.visible = true;
        },
        apiwbschedulemanagementget(id) {
            apiwbschedulemanagementget(id).then(({data}) => {
                if(data.code === '1') {
                    this.formData = data.data;
                }
            })
        },
        submitHandle() {//提交
            this.$refs.formData.validate(valid => {
                if(valid) {
                    apiwbschedulemanagementsave(this.formData).then(({data}) => {
                        if(data.code === '1') {
                            this.$message.success('操作成功');
                            this.$emit('on-sumit');
                            this.visible = false;
                        }else {
                            this.$message.error(data.msg)
                        }
                    })
                }else {
                    return false;
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.schmodal {
    .schmodal-btns {
        margin-top: 40px;
        text-align: center;
    }
}
</style>